import { render, staticRenderFns } from "./VueRadio.vue?vue&type=template&id=dee200f4&"
import script from "./VueRadio.vue?vue&type=script&lang=js&"
export * from "./VueRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports